// src/components/MatomoErrorBoundary.js
import React from 'react';

class MatomoErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Log the error and update state to render the fallback
    console.error('Matomo failed to load, rendering app without it:', error);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // If Matomo crashes, render the fallback (your <App />)
      return this.props.fallback;
    }

    // Otherwise, render the Matomo provider
    return this.props.children;
  }
}

export default MatomoErrorBoundary;